import styled from '@emotion/styled';
import React from 'react';

interface SectionProps {
    spacing: number;
    children: React.ReactNode;
}

export const Section = (props: SectionProps) => {
    return (
        <SectionContainer spacing={props.spacing}>
            {props.children}
        </SectionContainer>
    );
};

export const FormSection = (props: SectionProps) => {
    return (
        <FormSectionContainer spacing={props.spacing}>
            {props.children}
        </FormSectionContainer>
    );
};

const SectionContainer = styled.div<{ spacing: number }>`
    margin-bottom: ${(props) => props.spacing}px;
`;

const FormSectionContainer = styled.div<{ spacing: number }>`
    margin-bottom: ${(props) => props.spacing}px;
`;
